import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { ClientsCommentsSlider } from './components/clients-comments-slider';
import * as Styled from './styles';
import * as SX from './sx';
import type { ClientsCommentsProps as Props } from './types';

export const ClientsComments = memo(({ className }: Props) => {
  return (
    <Styled.Wrapper
      className={classnames('ClientsComments', className)}
      sx={SX.root}
    >
      <ClientsCommentsSlider />
    </Styled.Wrapper>
  );
});

ClientsComments.displayName = 'ClientsComments';
